module.exports = __webpack_public_path__ + "img/saving__snip.3040dfd2.png";